/**
 * Element UI – Buy button form
 */

import config from './config'
import cpSite from './cpSite'
// import { loadScript } from './loadScript'
import { waitModuleReady } from './waitModuleReady'
import vueBase from '../purchase-form/base'
import vueTableForm from '../purchase-form/tableForm'
import vueCustomerForm from '../purchase-form/customerForm'

let init = false

const purchaseForm = {
  depend: ['vue', 'element-ui'],
  state: {
    isActive: false,
    apiUrl: config.DEVMODE ? '//d8/api/purchase' : 'https://cryptopro.ru/api/purchase'
  },
  integrate: function () {
    if (config.DEVMODE) {
      console.log('integrate: hasBuyHash')
    }
    window.addEventListener('DOMContentLoaded', () => {
      if (window.location.hash === '#smartbuy') {
        cpSite.module.purchaseForm.activate()
      }
    })
    window.addEventListener('hashchange', () => {
      if (window.location.hash === '#smartbuy') {
        cpSite.module.purchaseForm.activate()
      }
    })
  },
  activate: function () {
    if (cpSite.config.DEVMODE) {
      console.log('active: purchaseForm')
    }
    // Не проводить повторную инициализацию
    if (init) {
      // Если инициализация началась, но не дошла до конца (не загрузились библиотеки), то перезагрузить страницу
      if (!cpSite.module.purchaseForm?.show) {
        window.location.reload()
      }
      cpSite.module.purchaseForm.show()
      return
    }

    // Критерий дальнейшего запуска
    const querySelector = 'purchase-form'
    const purchaseEl = document.querySelector(querySelector)
    // Если объекта нет, то добавить
    if (!purchaseEl) {
      if (config.DEVMODE) {
        console.log('purchseForm: no element and add')
      }
      // Вставка элемента для наполнения и продолжить
      document.body.insertAdjacentHTML('beforeend', '<purchase-form></purchase-form>')
    }

    // Инициализация
    init = true
    this.activateElementUi(this)
    // Ожидание готовности новых скриптов
    waitModuleReady(() => (window.Vue && window.Vue.options.components?.ElButton), () => { this.activateRuLang() }, 30)
  },
  activateElementUi () {
    cpSite.module.elementUi.activate()
  },
  activateRuLang () {
    cpSite.module.elementUi.ru()
    waitModuleReady(() => (window.ELEMENT && window.ELEMENT.lang?.ruRU), () => { this.embedPurchaseForm() }, 30)
  },
  embedPurchaseForm () {
    window.Vue.prototype.$formatNumber = function (value) {
      if (value == null) return ''
      // «ru-RU» по умолчанию использует неразрывный пробел
      return new Intl.NumberFormat('ru-RU').format(value)
    }
    new window.Vue({
      ...vueBase, // Используем базовый шаблон
      components: {
        'table-form': vueTableForm, // Локальная регистрация компонента
        'customer-form': vueCustomerForm // Локальная регистрация компонента
      }
    }).$mount('purchase-form')
    // loadScript(this.state.lib[0])
    // loadScript(this.state.lib[1])
    this.state.isActive = true
  },
  normalizeApostrophes (input) {
    // Символы, которые часто путают с апострофом
    const wrongApostrophes = /[’‘`´]/g
    // Заменяем их на стандартный апостроф (U+0027)
    return input.replace(wrongApostrophes, "'")
  }
}
export default purchaseForm
